
//import { createApp } from 'vue'
//import App from './App.vue'
//const app = createApp(App);

import { getApp } from './utils/public'
import router from './router'
import store from './store'
const app = getApp();

import { loadPlugins } from './utils/export'
// 加载组件
loadPlugins(app)

app.use(store).use(router).mount('#app')
